import React, { Component } from "react";

import LoginInput from "../../../shared/items/contols/loginInput";

import styles from "./restorePassword.module.scss";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { withRestore } from "../../../shared/containers/containerRestore";

class RestorePasswordForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hiddenPassword: true,
    };
  }

  render() {
    const { onHandleChangeStore, restore } = this.props;
    const { hiddenPassword } = this.state;

    return (
      <React.Fragment>
        <div className={styles.passwordInput}>
          <LoginInput
            name="password"
            type={hiddenPassword ? "password" : "text"}
            store={restore.restoreItems}
            handleChangeStore={onHandleChangeStore}
            placeholder="Новый пароль"
            errors={restore.errors}
          />
          <div className={styles.showPassordIconWraper}>
            <div
              className={styles.showPassordIcon}
              onClick={() => {
                this.setState({ hiddenPassword: !hiddenPassword });
              }}
            >
              {hiddenPassword ? <VisibilityOffIcon fontSize={"small"} /> : <VisibilityIcon fontSize={"small"} />}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default withRestore(RestorePasswordForm);
